import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

export const EmailTest = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    
    console.log("Starting email test");
    console.log("Form:", form.current);

    emailjs.sendForm('service_53qr5z4', 'template_rlb6nlj', form.current, 'TPky5aMDw7GZv2JUS')
      .then((result) => {
          console.log(result.text);
          alert("Email sent successfully!");
      }, (error) => {
          console.log(error.text);
          alert("Failed to send email. Error: " + error.text);
      });
  };

  return (
    <div style={{padding: '20px', maxWidth: '500px', margin: '0 auto'}}>
      <h2>Email Test Form</h2>
      <form ref={form} onSubmit={sendEmail} style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
        <label>Name</label>
        <input type="text" name="user_name" />
        <label>Email</label>
        <input type="email" name="user_email" />
        <label>Phone</label>
        <input type="tel" name="user_phone" />
        <label>Service</label>
        <select name="service">
          <option value="">Select a service</option>
          <option value="Demolition">Demolition</option>
          <option value="Site Clearing">Site Clearing</option>
        </select>
        <label>Message</label>
        <textarea name="message" />
        <input type="submit" value="Send Test Email" style={{marginTop: '10px', padding: '10px', background: '#ff8c00', color: 'white', border: 'none'}} />
      </form>
    </div>
  );
}; 